(function () {
    XonBoard.DynamicFormWithCount = {
        form_data: function (count, as, initial) {
            var initial_rows = initial || [];

            let index = 0;
            initial_rows = initial_rows.map(function (item) {
                item.index = index++;
                return item;
            });

            if(count != initial_rows.length) {
                count = initial_rows.length;
            }

            return {
                count: count,
                as: as,
                initial_rows: initial_rows,
                rows: initial_rows,
                // workaround as sorting does not work properly
                s: 1,
                empty_row() {
                    let index =this.last_index();
                    return {
                        index: index,
                        address: index,
                        sort: index + this.s,
                    };
                },
                countChanged() {
                    if(this.count < this.initial_rows.length) {
                        this.initial_rows.splice(this.count);
                        return;
                    }

                    let diff = this.count - this.initial_rows.length;

                    while(diff > 0) {
                        this.add_row();
                        diff--;
                    }
                },
                last_index() {
                    return (this.rows || []).length;
                },
                reset() {
                    this.rows = this.initial_rows;
                },
                setRows(rows) {
                    this.rows = rows;
                },
                init() {
                    var self = this;
                    document.addEventListener('create-modal-closed', function () {
                        self.reset();
                        XonBoard.Utils.Select2.reset();
                    });
                },
                add_row() {
                    this.rows.push(this.empty_row())
                },
                insert_row(i) {
                    this.rows.splice(i + 1, 0, this.empty_row())
                },
                remove_row(row_index) {
                    this.rows.splice(row_index, 1)
                }
            };
        }
    }
})();
